function setConsentCookie() {
  const expiryDate = new Date();
  // 2 years
  expiryDate.setTime(expiryDate.getTime() + 2 * 365 * 24 * 60 * 60 * 1000);

  window.document.cookie = `_inkl_cookie_consent=true;expires=${expiryDate.toUTCString()};path=/`;
}

function setConsentGranted() {
  const gtag = window.gtag;
  if (gtag) {
    gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
    });
  }
}

function initCookieBanner() {
  const cookieBanner = document.getElementById("cookie-banner");
  const acceptButton = document.getElementById("cookie-banner-accept");

  if (!cookieBanner || !acceptButton) {
    return;
  }

  acceptButton.addEventListener("click", () => {
    cookieBanner.classList.add("animate-fade", "opacity-0");

    setConsentCookie();
    setConsentGranted();

    setTimeout(() => {
      cookieBanner.remove();
    }, 500);
  });

  setTimeout(() => {
    cookieBanner.classList.remove("hidden");
  }, 1000);
}

document.addEventListener("DOMContentLoaded", initCookieBanner);
